var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('back-to-dashboard'),(_vm.viewingSubscriber)?_c('div',[_vm._v("viewing...")]):_c('div',[_c('creator-subscriber-index')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }